<template>
  <div>
    <vs-table
      search
      stripe
      border
      description
      :sst="true"
      :data="table.data"
      :max-items="table.length"
      :total="table.total"
      @search="handleSearch"
      @change-page="handleChangePage"
      @sort="handleSort"
    >
      <template slot="header">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ this.table.start }} - {{ this.table.end }} of
              {{ this.table.total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="item in table.limits"
              :key="item"
              @click="handleChangelength(item)"
            >
              <span>{{ item }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>
      <template slot="thead">
        <vs-th></vs-th>
        <vs-th sort-key="p.name">Name</vs-th>
        <vs-th sort-key="p.work_id_number">Work ID No.</vs-th>
        <vs-th sort-key="p.code_external">Ex. Code</vs-th>
        <vs-th sort-key="ud.app_platform">Platform</vs-th>
        <vs-th sort-key="ud.app_version">Version</vs-th>
        <vs-th sort-key="ud.manufacture">Manufacture</vs-th>
        <vs-th sort-key="ud.brand">Brand</vs-th>
        <vs-th sort-key="ud.model">Model</vs-th>
        <vs-th sort-key="ud.timezone">Timezone</vs-th>
        <vs-th sort-key="ud.user_agent">User Agent</vs-th>
        <vs-th sort-key="ud.os">OS</vs-th>
        <vs-th sort-key="ud.device_id">Device ID</vs-th>
        <vs-th sort-key="ud.last_login_at">Last Login At</vs-th>
        <vs-th sort-key="ud.last_activity_at">Last Activity At</vs-th>
        <vs-th sort-key="ud.status">Status</vs-th>
        <vs-th sort-key="ud.log_out_at">Logout At</vs-th>
        <vs-th sort-key="ud.inactive_at">Inactive At</vs-th>
        <vs-th sort-key="ud.inactive_by">Inactive By</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <!-- <vs-td>
            <div class="vx-input-group flex">
              <vs-button
                @click.stop="handleDelete(data[indextr].id)"
                size="small"
                color="danger"
                icon-pack="feather"
                icon="icon-trash"
                title="Delete"
              />
            </div>
          </vs-td> -->
          <vs-td>
            <div class="vx-input-group flex">
              <vs-button
                v-if="data[indextr].status != 'Inactive'"
                @click.stop="handleInactive(data[indextr].id)"
                size="small"
                color="danger"
                icon-pack="feather"
                icon="icon-x"
                title="Inactive"
              />
            </div>
          </vs-td>
          <vs-td :data="data[indextr].name">
            {{ data[indextr].name }}
          </vs-td>
          <vs-td :data="data[indextr].work_id_number">
            {{ data[indextr].work_id_number }}
          </vs-td>
          <vs-td :data="data[indextr].code_external">
            {{ data[indextr].code_external }}
          </vs-td>
          <vs-td :data="data[indextr].app_platform">
            {{ data[indextr].app_platform }}
          </vs-td>
          <vs-td :data="data[indextr].app_version">
            {{ data[indextr].app_version }}
          </vs-td>
          <vs-td :data="data[indextr].manufacture">
            {{ data[indextr].manufacture }}
          </vs-td>
          <vs-td :data="data[indextr].brand"> {{ data[indextr].brand }} </vs-td>
          <vs-td :data="data[indextr].model">
            {{ data[indextr].model }}
          </vs-td>
          <vs-td :data="data[indextr].timezone">
            {{ data[indextr].timezone }}
          </vs-td>
          <vs-td :data="data[indextr].user_agent">
            {{ data[indextr].user_agent }}
          </vs-td>
          <vs-td :data="data[indextr].os">
            {{ data[indextr].os }}
          </vs-td>
          <vs-td :data="data[indextr].device_id">
            {{ data[indextr].device_id }}
          </vs-td>
          <vs-td :data="data[indextr].last_login_at">
            {{ setWitToUtcToLocal(data[indextr].last_login_at) }}
          </vs-td>
          <vs-td :data="data[indextr].last_activity_at">
            {{ setWitToUtcToLocal(data[indextr].last_activity_at) }}
          </vs-td>
          <vs-td :data="data[indextr].status">
            {{ data[indextr].status }}
          </vs-td>
          <vs-td :data="data[indextr].log_out_at">
            {{ setWitToUtcToLocal(data[indextr].log_out_at) }}
          </vs-td>
          <vs-td :data="data[indextr].inactive_at">
            {{ setWitToUtcToLocal(data[indextr].inactive_at) }}
          </vs-td>
          <vs-td :data="data[indextr].inactive_by">
            {{ data[indextr].inactive_by }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination
      style="padding-top: 5px"
      :total="table.totalPage"
      v-model="setPage"
    />
  </div>
</template>
<script>
import moment from "moment";
export default {
  components: {},
  props: {
    baseUrl: {
      type: String,
    },
  },
  data() {
    return {
      deleteId: null,
      table: this.tableDefaultState(),
    };
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 1,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get(this.baseUrl + "/table", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records;
            this.setStartEnd();
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;

      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
        this.table.totalSearch < this.table.total &&
        this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    handleDelete(id) {
      this.deleteId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Please confirm to delete this data",
        accept: this.acceptDelete,
      });
    },
    acceptDelete() {
      this.$vs.loading();
      this.$http
        .delete(this.baseUrl + "/" + this.deleteId + "/delete")
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "The data was successfully deleted",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
          this.getData();
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    handleInactive(id) {
      this.deleteId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Please confirm to inactive this data",
        accept: this.acceptInactive,
      });
    },
    acceptInactive() {
      this.$vs.loading();
      this.$http
        .delete(this.baseUrl + "/" + this.deleteId + "/status-inactive")
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "The data was successfully inactive",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
          this.getData();
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    setUtcToLocal(time) {
      return moment(time).local().format();
    },
    setWitToUtcToLocal(val) {
      if (val) {
        return moment(val)
          .add(-7, "h")
          .utc()
          .local()
          .format("DD MMM YYYY HH:mm:ss");
      }
    },
  },
  mounted() {},
  watch: {},
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>
